import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/image/logo.jpeg";
import { useForm } from "react-hook-form";
import { BASE_URL, HEADERS } from "../../utils/constant";
import { collapseToast, toast } from "react-toastify";
import axios from "axios";
import { Button, Spinner } from "react-bootstrap";

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: { email_or_phone: username || "" },
  });

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/users/login/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response?.data?.message) {
        toast.success(response.data.message);
      }

      if (response?.data) {
        localStorage.setItem("email_or_phone", data.email_or_phone);
        navigate("/otpverification");
      }
    } catch (error) {
      const errData = error?.response?.data;
      if (errData?.non_field_errors?.length) {
        toast.error(errData.non_field_errors[0]);
      } else if (errData?.error) {
        try {
          let parsedError = errData.error;
          if (typeof parsedError === "string") {
            parsedError = JSON.parse(parsedError);
          }
          if (Array.isArray(parsedError) && parsedError.length > 0) {
            toast.error(parsedError[0]);
          } else {
            toast.error(String(parsedError));
          }
        } catch {
          toast.error(errData.error.replace(/[\[\]"]+/g, ""));
        }
      } else if (errData?.message) {
        toast.error(errData.message);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-vh-100 d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div
              className="card border-0 shadow-lg overflow-hidden rounded-5 d-flex flex-column flex-md-row"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.97)",
              }}
            >
              <div
                className="col-md-6 p-0 d-none d-md-flex"
                style={{
                  backgroundColor: "#f9fafb",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid w-100 h-100"
                  style={{
                    objectFit: "cover",
                    filter: "brightness(0.95)",
                  }}
                />
              </div>
              <div
                className="col-md-6 col-12 d-flex align-items-center justify-content-center"
                style={{
                  padding: "2rem 1.5rem",
                  minHeight: "500px",
                  backgroundColor: "#ffffff",
                }}
              >
                <div className="w-100" style={{ maxWidth: "400px" }}>
                  <div className="text-center mb-4">
                    <h2
                      className="fw-bold"
                      style={{ fontSize: "1.9rem", color: "#222" }}
                    >
                      Welcome Back 👋
                    </h2>
                    <p style={{ color: "#666", fontSize: "1rem" }}>
                      Log in to access your dashboard and manage everything
                      effortlessly.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-floating mb-3 custom-input-container">
                      <input
                        type="text"
                        className={`form-control custom-input ${
                          errors.email_or_phone ? "is-invalid" : ""
                        }`}
                        {...register("email_or_phone", {
                          required: "Mobile number or email is required",
                          pattern: {
                            value: /^(?:\d{10}|\S+@\S+\.\S+)$/,
                            message: "Invalid mobile number or email format",
                          },
                        })}
                        placeholder=" "
                      />
                      <label htmlFor="email_or_phone" className="custom-label">
                        Email Or Mobile Number*
                      </label>
                      {errors.email_or_phone && (
                        <div className="invalid-feedback">
                          {errors.email_or_phone.message}
                        </div>
                      )}
                    </div>

                    <div className="btn-container d-flex justify-content-end mt-4">
                      <button className="login-btn" disabled={loading}>
                        {loading ? (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          ></div>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </div>

                    <p className="text-center mt-4">
                      New user?{" "}
                      <Link
                        to="/signup"
                        className="ms-1 text-decoration-none fw-semibold Link"
                      >
                        Sign up now
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
